import './ContactsPage.scss'

export const ContactsPage = () => {
  return (
    <section className="contacts">
      ContactsPage
    </section>
  );
};